import Resource from './common/resource';

class GroupsFolders extends Resource {
  path = 'bookmarks/folders';

  onCreateOne({ commit }, { model, res }) {
    commit('update', { model, update: res.data, action: 'append' });
  }
}

export default GroupsFolders;
